import React from 'react';
import { useAuth } from '../context/AuthContext';
import { DepartmentNav } from '../components/DepartmentNav';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { SEO } from '../components/SEO';

import { API_URL } from '../config/api';

export const DisclosurePage = () => {
  const { user } = useAuth();

  return (
    <div data-testid="disclosure-page" className="min-h-screen bg-background">
      <SEO
        title="Affiliate Disclosure"
        description="TurfPulse's affiliate program disclosure — Amazon Associates, Awin, DoMyOwn, FTC compliance, and our recommendation commitments."
        path="/disclosure"
      />
      {user && <DepartmentNav />}

      <div className="max-w-3xl mx-auto p-6 space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Affiliate Disclosure</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-sm dark:prose-invert max-w-none space-y-4 text-foreground">
            <p>
              <strong>TurfPulse</strong> (getturfpulse.com) participates in multiple affiliate
              programs designed to provide a means for content sites to earn advertising fees by
              linking to merchants our audience already wants to buy from:
            </p>
            <ul>
              <li><strong>Amazon Services LLC Associates Program</strong> — earnings from qualifying purchases on Amazon.com.</li>
              <li><strong>Awin Network</strong> — including <strong>DoMyOwn.com</strong> (pro-grade lawn-care chemistry, fungicides, herbicides, equipment) and other approved Awin advertisers as they're added.</li>
            </ul>

            <h3 className="text-lg font-bold mt-6">What This Means for You</h3>
            <p>
              When you click on product links on this site labeled "Buy on Amazon," "Buy on
              DoMyOwn," or any other affiliate-marked link and make a purchase, TurfPulse may
              earn a small commission at no additional cost to you. These commissions help support
              the development and maintenance of TurfPulse and allow us to continue providing free
              lawn care tools and content.
            </p>

            <h3 className="text-lg font-bold mt-6">Our Commitment</h3>
            <p>
              We only recommend products that we believe are genuinely useful for lawn care. Our
              product recommendations are based on active ingredients, efficacy, and value — not
              on which programs or merchants pay the highest commissions. Product information,
              application rates, and GDD timing data are provided for educational purposes.
            </p>

            <h3 className="text-lg font-bold mt-6">Trademarks</h3>
            <p>
              Amazon and the Amazon logo are trademarks of Amazon.com, Inc. or its affiliates.
              DoMyOwn and the DoMyOwn logo are trademarks of DoMyOwn, LLC. Awin is a trademark of
              Awin Ltd. All other merchant trademarks are the property of their respective owners.
              As an Amazon Associate and Awin publisher, TurfPulse earns from qualifying purchases.
            </p>

            <h3 className="text-lg font-bold mt-6">FTC Disclosure</h3>
            <p>
              In accordance with the Federal Trade Commission's 16 CFR Part 255, "Guides Concerning
              the Use of Endorsements and Testimonials in Advertising," this site contains affiliate
              links that may result in compensation to TurfPulse. All opinions expressed on this
              site are our own.
            </p>

            <h3 className="text-lg font-bold mt-6">Product Pricing</h3>
            <p>
              Product prices and availability displayed on TurfPulse are estimates based on the
              manufacturer's suggested retail pricing and may differ from current Amazon pricing.
              For the most current pricing, please click through to Amazon.com.
            </p>

            <h3 className="text-lg font-bold mt-6">Contact</h3>
            <p>
              If you have questions about this disclosure or our affiliate relationships, please
              contact us at <a href="mailto:support@getturfpulse.com" className="text-primary hover:underline">support@getturfpulse.com</a>.
            </p>

            <p className="text-muted-foreground text-xs mt-8">
              Last updated: April 2, 2026
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
